const HourlyMain: React.FC = () => <Outlet />;
export default HourlyMain;
